
import { defineComponent } from "vue";
import CategoriesContent from "./Components/CategoriesContent.vue";

export default defineComponent({
  name: "CategoriesPage",
  components: {
    CategoriesContent
  },
});
